module.exports = __webpack_public_path__ + "img/1557614096395870209.26e4e7d8.png";